import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import PageTracker from './components/PageTracker';
import Home from './pages/Home';
import Services from './pages/Services';
import Resources from './pages/Resources';
import WhyPSN from './pages/WhyPSN';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Login from './pages/Login';
import AIAppCorner from './pages/AIAppCorner';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <PageTracker />
      <div className="App min-h-screen flex flex-col">
        <Navigation />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/why-psn" element={<WhyPSN />} />
            <Route path="/ai-app-corner" element={<AIAppCorner />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;